import React, { Fragment } from 'react';
import {
  Toggle,
  Input,
  SliderWrapper,
  Slider,
  LightModeIcon,
  DarkModeIcon,
  PartnerInput,
  PartnerSliderWrapper,
  RegionalsInput,
  RegionalsSliderWrapper,
  JuniorsInput,
  JuniorsSliderWrapper,
  ThemeToggle,
  ThemeInput,
  ThemeSliderWrapper,
  ThemeSlider,
} from './styles';

export default function ToggleSwitch({ checked, onChange, isPricing, themeToggler, darkTheme, variant }) {
  return (
    <Fragment>
      {themeToggler ? (
        <ThemeToggle themeToggler={themeToggler}>
          <ThemeInput type="checkbox" checked={checked} onChange={onChange} themeToggler={themeToggler} darkTheme={darkTheme} />
          <ThemeSliderWrapper themeToggler={themeToggler} darkTheme={darkTheme}>
            <ThemeSlider themeToggler={themeToggler}>{darkTheme ? <DarkModeIcon /> : <LightModeIcon />}</ThemeSlider>
          </ThemeSliderWrapper>
        </ThemeToggle>
      ) : (
        <Toggle>
          {/*{variant === 'partner-plus' ? (
            <Fragment>
              <PartnerInput type="checkbox" checked={checked} onChange={onChange} darkTheme={darkTheme} />
              <PartnerSliderWrapper isPricing={isPricing} darkTheme={darkTheme}>
                <Slider />
              </PartnerSliderWrapper>
            </Fragment>
          ) : variant === 'regionals' ? (
            <Fragment>
              <RegionalsInput type="checkbox" checked={checked} onChange={onChange} darkTheme={darkTheme} />
              <RegionalsSliderWrapper isPricing={isPricing} darkTheme={darkTheme}>
                <Slider />
              </RegionalsSliderWrapper>
            </Fragment>
          ) : variant === 'code-juniors' ? (
            <Fragment>
              <JuniorsInput type="checkbox" checked={checked} onChange={onChange} darkTheme={darkTheme} />
              <JuniorsSliderWrapper isPricing={isPricing} darkTheme={darkTheme}>
                <Slider />
              </JuniorsSliderWrapper>
            </Fragment>
          ) : (
          )}*/}
          <Fragment>
            <Input type="checkbox" checked={checked} onChange={onChange} darkTheme={darkTheme} />
            <SliderWrapper isPricing={isPricing} darkTheme={darkTheme}>
              <Slider />
            </SliderWrapper>
          </Fragment>
        </Toggle>
      )}
    </Fragment>
  );
}
